<template>
    <div>
        <webix-ui :config="ui" v-model="clients"></webix-ui>
        <div id="clientPaging"></div>
    </div>
</template>

<script>
import clientDetails from "./clientDetails.vue";
import Swal from "sweetalert2";
import { clientMethods, clientComputed } from "@/state/helpers";
export default {
    //eslint-disable-next-line
    components: { clientDetails },
    data: () => ({}),
    computed: {
        ...clientComputed,
        ui() {
            //eslint-disable-next-line
            let el = this;

            let ui = {
                id: "clientsTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border",
                autoheight: true,
                //hover: "datatableHover",
                minHeight: 60,
                //minColumnWidth: 120,
                rowHeight: 40,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                select: false,
                pager: {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "clientPaging",
                    css: { width: "100% !important" },
                    size: 15,
                    group: 5,
                },
                columns: [
                    {
                        id: "actions",
                        header: "Actions",
                        width: 120,
                        template: function () {
                            return `
                        <div class="tableIcons">
                            <i class="mdi mdi-trash-can deleteAction"></i>
                            <i class="mdi mdi-eye viewAction"></i>
                            &nbsp;&nbsp;
                            </div>`;
                        },
                    },
                    {
                        id: "company_name",
                        header: ["Company Name", { content: "textFilter" }],
                        tooltip: false,
                        sort: "string",
                        width: 200,
                    },
                    {
                        id: "type",
                        header: ["Type", { content: "selectFilter" }],
                        tooltip: false,
                        width: 180,
                    },
                    {
                        id: "last_order_date",
                        header: ["Last Order Date", { content: "textFilter" }],
                        sort: "string",
                        tooltip: false,
                        width: 180,
                    },
                    {
                        id: "assigned_reps",
                        header: ["Assigned Agents", { content: "textFilter" }],
                        tooltip: false,
                        sort: "string",
                        width: 180,
                    },
                    /*{
                        id: "company_reg",
                        header: ["Company Reg", { content: "textFilter" }],
                        fillspace: 0.8,
                    },
                    {
                        id: "vat_no",
                        header: ["VAT No", { content: "textFilter" }],
                        fillspace: 0.8,
                    },*/
                    {
                        id: "contact_person",
                        header: ["Contact Person", { content: "textFilter" }],
                        width: 180,
                    },
                    {
                        id: "emails",
                        header: ["Email", { content: "textFilter" }],
                        width: 180,
                    },
                    /*{
                        id: "customer_no",
                        header: ["Customer No", { content: "selectFilter" }],
                        fillspace: 0.6,
                    },*/
                    {
                        id: "city",
                        header: ["City", { content: "selectFilter" }],
                        width: 180,
                    },
                    {
                        id: "postal_code",
                        header: ["Postal Code", { content: "selectFilter" }],
                        width: 180,
                    },
                    {
                        id: "province",
                        header: ["Province", { content: "selectFilter" }],
                        width: 180,
                    },
                    {
                        id: "address",
                        header: ["Address", { content: "textFilter" }],
                        width: 180,
                    },
                ],
                ready() {
                    // el.resize_event = window.webix.event(window, "resize", function () {
                    //     if (el.ui.id)
                    //         el.$nextTick(() => {
                    //             window.webix.$$(el.ui.id).refresh();
                    //         });
                    // });
                },
                onClick: {
                    //eslint-disable-next-line
                    // viewAction: function (id, e, trg) {
                    //     //NB: this.getItem(e.row) will return the id if it is in the object in the store
                    //     let el = this.$scope.$parent;
                    //     el.setSelectedClientId(e.row);
                    // },
                    //eslint-disable-next-line
                    viewAction: function (id, e, trg) {
                        //NB: this.getItem(e.row) will return the id if it is in the object in the store
                        let el = this.$scope.$parent;

                        let idForUrl = e.row;

                        el.setSelectedClientId(e.row);

                        el.$router.push({
                            path: `/clients/view/${idForUrl}`,
                            param: { idForUrl },
                        });
                    },

                    //eslint-disable-next-line
                    deleteAction: function (id, e, trg) {
                        const el = this.$scope.$parent;
                        const item = this.getItem(e.row);

                        el.handleSwal(item, e);
                    },
                },
            };
            return ui;
        },
    },
    methods: {
        ...clientMethods,
        handleSwal(item, e) {
            Swal.fire({
                title: `Are you sure you want to delete
                            "${item.company_name}" ?`,
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, delete!",
            }).then((result) => {
                if (result.value) {
                    this.ready = false;
                    this.deleteClient({ id: e.row }).then(() => {
                        // el.getStockists().then(() => {
                        //     el.ready = true;
                        // });
                        Swal.fire("Client was deleted", "", "success");

                        //refresh the table on the screen
                        this.getClients();
                    });
                }
            });
        },
    },
    mounted() {
        //get the data for the table
        if (this.clients.length == 0) {
            this.getClients();
        }
    },
};
</script>

<style lang="scss" scoped></style>
